module.exports = __webpack_public_path__ + "static/characteristics-cf747730dd5ac02a72278f3ce2bc375e.png";